<template lang="pug">
  .planned-purchases
    e-modal(
      ref="modalForm"
      @confirm="savePlannedForm"
      @close="closeForm"
      :title="title"
      :hideDeleteButton="false"
    )
      slot
        e-form(:formValidator="formValidator")
          div.body-wrapper.cuscroll
            div
              div.body
                div.col
                  e-form-group(
                    name="name"
                    inputType="textarea"
                    label="Наименование контейнера"
                    :model="fields"
                    tabView="tab1"
                    :required="true"
                    placeholder=" "
                  )
                  e-form-group(
                    name="measure_id"
                    inputType="select"
                    label="Единица измерения"
                    :model="fields"
                    tabView="tab1"
                    :options="measureTypes"
                    :required="true"
                  )
</template>

<script>
import formBaseMixin from '@/components/form/form-base-mixin'
import { core, tko } from '@/api/api-endpoints'

export default {
  name: 'add-plan-table',
  mixins: [formBaseMixin],
  title: function () {
    return this.title
  },
  props: {
    tko_operator_id: {
      type: Number,
    },
    year: {
      type: Number,
    },
  },
  data() {
    return {
      fields: {
        name: '',
        measure_id: '',
      },
    }
  },
  computed: {
    title() {
      if (this.$route.query.checkedReg) {
        if (this.$route.query.checkedReg != 0) {
          return 'Редактирование'
        }
      }
      return 'Добавление'
    },
    measureTypes() {
      let measures = this.$store.getters.readUrlEndpoint(
        this.getCollectionEndpoint()
      ).measure
      const measure = measures.filter((item) => item.name === 'руб.')
      this.fields.measure_id = measure[0].id
      return measure
    },
  },
  methods: {
    closeForm() {
      this.$emit('close')
    },
    async savePlannedForm() {
      await this.$store.dispatch('createModel', {
        url: tko.operatorPlannedPurchasesUpdate({
          query: { tko_operator_id: this.tko_operator_id },
        }),
        data: {
          name: this.fields.name,
          year: this.year,
        },
      })
      this.closeForm()
    },
    getCollectionEndpoint() {
      return core.collection('measure', {
        query: {
          type: 'indicator',
        },
      })
    },
  },
}
</script>

<style scoped lang="scss"></style>
